<template>
    <div>
      <div class="master-section" :class="row.which_layout === 'textRight' ? 'text-right-layout' : 'text-left-layout'">
        <section class="row align-items-center text-md-left px-0 px-md-1 mb-md-60px mb-40px mx-0 mx-md-1">
          <div :class="['col-12 col-md-6 px-md-0' , row.which_layout === 'textRight' ? '' : 'order-md-1 offset-md-1']">
            <template v-if="row.link_type === 'section'">
              <a :href="row.button_link.url" :target="row.button_link.target || '_self'">
                <template v-if="row.media.type === 'image'">
                  <img class="img-fluid d-inline d-md-none mb-30px mb-md-0px" :src="row.media.image_full_mb ? row.media.image_full_mb : row.media.image_full" :alt="row.media.alt ?? ''" />
                  <img class="img-fluid d-none d-md-inline mb-30px mb-md-0px" :src="row.media.image_full" :alt="row.media.alt ?? ''" />
                </template>
                <template v-if="row.media.type === 'video' && row.media.url">
                  <div class="alt-video-wrapper alt-left-col-layout">
                    <video class="master_video" muted playsinline repeat :autoplay="row.media.autoplay" :controls="row.media.controls">
                      <source :src="row.media.url" type="video/mp4">
                    </video>
                  </div>
                </template>
                <template v-if="row.media.type === 'embed'">
                  <div class="master_video_embed_container" v-html="row.media.code"></div>
                </template>
              </a>
            </template>
            <template v-if="row.link_type === 'none'">
                <template v-if="row.media.type === 'image'">
                  <img class="img-fluid d-inline d-md-none mb-30px mb-md-0px" :src="row.media.image_full_mb ? row.media.image_full_mb : row.media.image_full" :alt="row.media.alt ?? ''" />
                  <img class="img-fluid d-none d-md-inline mb-30px mb-md-0px" :src="row.media.image_full" :alt="row.media.alt ?? ''" />
                </template>
                <template v-if="row.media.type === 'video' && row.media.url">
                  <div class="alt-video-wrapper alt-left-col-layout">
                    <video class="master_video" muted playsinline repeat :autoplay="row.media.autoplay" :controls="row.media.controls">
                      <source :src="row.media.url" type="video/mp4">
                    </video>
                  </div>
                </template>
                <template v-if="row.media.type === 'embed'">
                  <div class="master_video_embed_container" v-html="row.media.code"></div>
                </template>
            </template>
            <template v-if="row.link_type === 'button'">
                <template v-if="row.media.type === 'image'">
                  <img class="img-fluid d-inline d-md-none mb-30px mb-md-0px" :src="row.media.image_full_mb ? row.media.image_full_mb : row.media.image_full" :alt="row.media.alt ?? ''" />
                  <img class="img-fluid d-none d-md-inline mb-30px mb-md-0px" :src="row.media.image_full" :alt="row.media.alt ?? ''" />
                </template>
                <template v-if="row.media.type === 'video' && row.media.url">
                  <div class="alt-video-wrapper alt-left-col-layout">
                    <video class="master_video" muted playsinline repeat :autoplay="row.media.autoplay" :controls="row.media.controls">
                      <source :src="row.media.url" type="video/mp4">
                    </video>
                  </div>
                </template>
                <template v-if="row.media.type === 'embed'">
                  <div class="master_video_embed_container" v-html="row.media.code"></div>
                </template>
            </template>
          </div>
  
          <div :class="['col-12 col-md-5 col-right', row.which_layout === 'textRight' ? 'offset-md-1' : 'order-md-0']">
            <template v-if="row.link_type === 'section'">
              <a :href="row.button_link.url" :target="row.button_link.target || '_self'">
                <h2 v-if="row.title" class="agp-normal mb-25px mt-25px" v-html="row.title"></h2>
                <p v-html="row.chinese_title"></p>
                <p class="agp-light" v-html="convertUrlsToLocale(row.description, baseUrl, locale)"></p>
              </a>
            </template>
            <template v-else>
              <h2 v-if="row.title" class="agp-normal mb-25px mt-25px" v-html="row.title"></h2>
              <p v-if="row.chinese_title" v-html="row.chinese_title"></p>
              <p v-if="row.description" class="agp-light" v-html="convertUrlsToLocale(row.description, baseUrl, locale)"></p>
              <a v-if="row.button_link.title && row.button_link && row.link_type === 'button'" class="btn-outline-dark btn" :href="getLangUrl(row.button_link.url, baseUrl, locale)" :target="row.button_link.target || '_self'">
                {{ row.button_link.title }}<span style="border-color: #000000" class="css-arrow css-arrow-right"></span>
              </a>
            </template>
          </div>
        </section>
      </div>
    </div>
  </template>
  
  
<script lang="ts" setup>
  const props = defineProps(["data"]);
  const response = computed(() => props.data);
  const row = response.value[0];
  const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.BASE_URL;
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { convertUrlsToLocale, getLangUrl } from '~/utils/getLangUrl';
</script>